const freejeetests = [
  {
    id: 2025,
    title: "JEE-Main 2025: 2 April 2025 (Mobile Test) - English",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/2april2025mobile",
  },
  {
    id: 2025,
    title: "JEE Main 2025: 22 Jan 2025 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/22jan2025shift1",
  },
  {
    id: 2025,
    title: "JEE Main 2025: 23 Jan 2025 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/23jan2025shift1",
  },
  {
    id: 2024,
    title: "JEE Main 2024: 27 Jan 2024 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/27jan2024shift1",
  },
  {
    id: 2024,
    title: "JEE Main 2024: 29 Jan 2024 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/29jan2024shift1",
  },
  {
    id: 2024,
    title: "JEE Main 2024: 4 April 2024 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/4april2024shift1",
  },
  {
    id: 2024,
    title: "JEE Main 2024: 5 April 2024 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/5april2024shift1",
  },
  {
    id: 2023,
    title: "JEE Main 2023: 24 Jan 2023 (Shift2)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/24jan2023shift2",
  },
  {
    id: 2023,
    title: "JEE Main 2023: 25 Jan 2023 (Shift2)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/25jan2023shift2",
  },
  {
    id: 2023,
    title: "JEE Main 2023: 6 April 2023 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/6april2023shift1",
  },
  {
    id: 2023,
    title: "JEE Main 2023: 8 April 2023 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/8april2023shift1",
  },
  {
    id: 2022,
    title: "JEE Main 2022: 24 June 2022 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/24june2022shift1",
  },
  {
    id: 2022,
    title: "JEE Main 2022: 25 June 2022 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/25june2022shift1",
  },
  {
    id: 2022,
    title: "JEE Main 2022: 25 July 2022 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/25july2022shift1",
  },
  {
    id: 2022,
    title: "JEE Main 2022: 26 July 2022 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/26july2022shift1",
  },
  {
    id: 2021,
    title: "JEE Main 2021: 24 Feb 2021 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/24feb2021shift1",
  },
  {
    id: 2021,
    title: "JEE Main 2021: 25 Feb 2021 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/25feb2021shift1",
  },
  {
    id: 2021,
    title: "JEE Main 2021: 16 March 2021 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/16march2021shift1",
  },
  {
    id: 2021,
    title: "JEE Main 2021: 17 March 2021 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/17march2021shift1",
  },
  {
    id: 2021,
    title: "JEE Main 2021: 20 July 2021 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/20july2021shift1",
  },
  {
    id: 2021,
    title: "JEE Main 2021: 22 July 2021 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/22july2021shift1",
  },
  {
    id: 2021,
    title: "JEE Main 2021: 26 Aug 2021 (Shift2)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/26aug2021shift2",
  },
  {
    id: 2021,
    title: "JEE Main 2021: 27 Aug 2021 (Shift2)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/27aug2021shift2",
  },
  {
    id: 2020,
    title: "JEE Main 2020: 7 Jan 2020 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/7jan2020shift1",
  },
  {
    id: 2020,
    title: "JEE Main 2020: 8 Jan 2020 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/8jan2020shift1",
  },
  {
    id: 2020,
    title: "JEE Main 2020: 2 Sep 2020 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/2sep2020shift1",
  },
  {
    id: 2020,
    title: "JEE Main 2020: 3 Sep 2020 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/3sep2020shift1",
  },
  {
    id: 2019,
    title: "JEE Main 2019: 9 Jan 2019 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/9jan2019shift1",
  },
  {
    id: 2019,
    title: "JEE Main 2019: 10 Jan 2019 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/10jan2019shift1",
  },
  {
    id: 2019,
    title: "JEE Main 2019: 8 April 2019 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/8april2019shift1",
  },
  {
    id: 2019,
    title: "JEE Main 2019: 9 April 2019 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/9april2019shift1",
  },
  {
    id: 2018,
    title: "JEE Main 2018: 15 April 2018 (Shift1)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/15april2018shift1",
  },
  {
    id: 2018,
    title: "JEE Main 2018: 15 April 2018 (Shift2)",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/15april2018shift2",
  },
  {
    id: 2017,
    title: "JEE Main 2017: 8 April 2017",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/8april2017",
  },
  {
    id: 2017,
    title: "JEE Main 2017: 9 April 2017",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/9april2017",
  },
  {
    id: 2016,
    title: "JEE Main 2016: 9 April 2016",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/9april2016",
  },
  {
    id: 2016,
    title: "JEE Main 2016: 10 April 2016",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/10april2016",
  },
  {
    id: 2015,
    title: "JEE Main 2015: 10 April 2015",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/10april2015",
  },
  {
    id: 2015,
    title: "JEE Main 2015: 11 April 2015",
    subject: "Physics | Chemistry | Mathematics",
    duration: "180 Minutes",
    route: "/test-series/pyq/jeemains/11april2015",
  },
];

export default freejeetests;